/**
 * Табы лучших игроков
 */
$.fn.topPlayersTabs = function() {
    const $self = $(this);
    const $showButton = $self.find('.js-btn-show');
    const $dropList = $self.find('.js-drop-list');
    const $dropListItems = $dropList.find('li');
    const $players = $self.find('.js-players li');

    /**
     * Открываем выбор таба
     */
    const toggleDropList = () => {
        $dropList.toggleClass('opened');
        $showButton.toggleClass('opened');
    };

    /**
     * Меняем таб
     * @param {jquery} $context
     */
    const changeTab = ($context) => {
        const $textContainer = $showButton.find('.js-text');
        const target = $context.data('target');

        $textContainer.text($context.text());
        $dropListItems.removeClass('active');
        $dropList.removeClass('opened');
        $showButton.removeClass('opened');
        $context.addClass('active');
        $players.removeClass('active');
        $players.filter((index, element) => {
            return $(element).data('name') === target;
        }).addClass('active');
    };

    /**
     * Инициализация событий
     */
    const initEvents = () => {
        $showButton.on('click', toggleDropList);
        $dropList.on('click', 'li', function () {
            changeTab($(this));
        });

        $(document).on('click', function (e) {
            const $target = $(e.target);

            if (!$target.closest('.js-top-players-drop').length) {
                $dropList.removeClass('opened');
                $showButton.removeClass('opened');
            }
        });
    };

    /**
     * Инициализация плагина
     */
    const init = () => {
        initEvents();
    };

    init();

};
